import moment from "moment";
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useParams, useLocation } from 'react-router-dom';
import CategoryFilter, { SortingItem } from "../public/HOC/CategoryFilter";
import PaginationListHOC from "../public/HOC/PaginationListHOC";
import "./CategoryItems.scss"
import { Breadcrumbs } from "shared/hoc/breadcrumbs/Breadcrumbs";
import { BREADCRUMB_TYPE_CONFIG } from "shared/hoc/breadcrumbs/config";
let pageSize = 48
const hidefilter = ["keyword"]
export default function CategoryItems(props) {
    const dispatch = useDispatch()
    const statemaintenance = useSelector(state => state?.statemaintenance);
    const category = useSelector(state => state?.category);
    const [filterData, setfilterData] = useState({})
    const [windowwidth, setwindowwidth] = useState(window?.innerWidth)
    const [currentpath, setcurrentpath] = useState("")
    const [viewModal, setviewModal] = useState(false)
    const [configeredData, setconfigeredData] = useState({})
    const sortval = useRef( [{ "field": "title", "direction": "asc" }])
    const [sortvalue , setSortValue] = useState(sortval.current[0].field + '___' + sortval.current[0].direction);
    const params = useParams();
    const location = useLocation()

    // NOTE: This will not change. Only initialized in the beginning.
    const prevCategoryData = useRef(params);

    useEffect(() => {
        window.addEventListener('resize', (resp) => {
            setwindowwidth(window?.innerWidth)
        });

        if (props.history.action !== 'REPLACE' && currentpath != props.location.pathname) {
            setcurrentpath(props.location.pathname)
            setfilterfromprops(params)
        }
        return () => { }
    }, [props.location.pathname]);
    
    const setfilterfromprops = async (param,reset=false) => {
        let filterData = { ...param }
        if (statemaintenance?.["Category"] && !reset ) {
            const categoryGroup = statemaintenance?.["Category"]?.filtervalue?.["categoryGroup"];
            const category = statemaintenance?.["Category"]?.filtervalue?.["category"];
            
            if ( categoryGroup !== params?.categoryGroup || category !== params?.category ) {
                props.history.replace(formCategoryUrlPath(categoryGroup, category));
                
                prevCategoryData.current = { categoryGroup, category };

                filterData = statemaintenance?.["Category"]?.filtervalue || filterData
            } else {
                sortval.current = statemaintenance?.["Category"]?.sort || sortval.current;
                setSortValue(sortval.current[0].field + '___' + sortval.current[0].direction);
            }
        }
        setfilterData((prevState) => {
            return { ...filterData }
        })
        let pusttoStore = { ...statemaintenance }
        delete pusttoStore["Category"] 
        dispatch({
            type: 'PUSH_TO_STATE', payload: pusttoStore
        });
        getitems({ ...filterData })

    }

    const formCategoryUrlPath = (categoryGroup, category) => {
        let url = '/category';
        if ( categoryGroup ) {
            url += `/${categoryGroup}`;
        }

        if ( category ) {
            url += `/${category}`;
        }
    
        return url;
    };

    const getitems = async (filterdata) => {
        let filter = [
        ]
        Object.keys(filterdata).map(item => {
            if (item in filterdata && filterdata?.[item] != "") {
                switch (item) {
                    case "min":
                        filter.push({ "field": "bidprice", "value": filterdata?.["min"], "op": ">=", "join": "AND" });
                        break
                    case "max":
                        filter.push({ "field": "bidprice", "value": filterdata?.["max"], "op": "<=", "join": "AND" });
                        break
                    case "startdate":
                        const  startDate =  moment.tz(filterdata?.["startdate"] + ' 00:00:00', "US/Eastern").utc().format("YYYY-MM-DD hh:mm:ss")
                        filter.push({ "field": "itemclosetime", "value": startDate, "op": ">=", "join": "AND" });
                        break;
                    case "enddate":
                        const endDate =  moment.tz(filterdata?.["enddate"] + ' 23:59:59', "US/Eastern").utc().format("YYYY-MM-DD hh:mm:ss")
                        filter.push({ "field": "itemclosetime", "value": endDate, "op": "<=", "join": "AND" });
                        break;
                    case "itemtype":
                        filterdata?.["itemtype"].forEach(itemstatus => {
                             if (itemstatus == "buynow") {
                                filter.push({ "field": "buynowprice", "value": 0, "op": ">", "join": "AND" });
                            } else if (itemstatus == "isshippable") {
                                filter.push({ "field": "isshippable", "value": 1, "op": "=", "join": "AND" });
                            } else if (itemstatus == "pickuponly") {
                                filter.push({ "field": "isshippable", "value": 0, "op": "=", "join": "AND" });
                            } else {
                                let itemtype = { auction: 2, directBuy: 1, onSite: 3 }
                                if(itemtype[itemstatus]) {
                                    filter.push({ "field": "itemtypeid", "value": itemtype[itemstatus], "op": "=", "join": "AND" });
                                }
                            }
                        });
                        break
                    default:
                        filter.push({ "field": item, "value": filterdata?.[item], "op": "=", "join": "AND" });
                        break
                }
            }

        })
       
        if (filterdata?.["itemtype"]?.includes("completed")) {
            filter.push({ "field": "itemstatus", "value": "Not Sold", "op": "=", "join": "OR" });
            filter.push({ "field": "itemstatus", "value": "Sold", "op": "=", "join": "OR" });
        } else{
            filter.push({ "field": "salestatus", "value": "Started", "op": "=", "join": "AND" });
            filter.push({ "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" });
        }

        const payload = {
            "sort": sortval.current,
            "page": { "size": pageSize },
            "field": ["id", "displayimageurl", "itemstatus", "itemtypeid", "itemtypename", "itemclosetime", "title", "isshippable", "saleid", "category", 'categoryGroup', 'thumbnailurl', 'itemseourl', "bidprice"],
            "filter": [
                // { "field": "itemtypeid", "value": 3, "op": "<", "join": "AND" },
                ...filter,]

        };
        let pusttoStore = { ...statemaintenance }
        pusttoStore["Category"] = {
            ... pusttoStore?.["Category"],
            filtervalue:{...filterdata},
            sort:sortval.current

        }
        dispatch({
            type: 'PUSH_TO_STATE', payload: pusttoStore
        });
        setconfigeredData({
            payload,
            count: 3,
            pageSize: pageSize,
            type: "Item",
            history: props?.history,
            heading:"Category"
        })
    }


    return (
        <>
            <Helmet>
                <title>CTBids | {"Category"}</title>
            </Helmet>
            <div style={{flex: '1'}}>
                {
                    filterData.categoryGroup ? 
                    <Breadcrumbs key={props.location.pathname + filterData.categoryGroup + filterData.category} props={props} type={BREADCRUMB_TYPE_CONFIG.CATEGORY} options={{ addOnBreadcrumbs: ['Category', `${filterData.categoryGroup}`, filterData.category ? `${filterData.category}` : null] }} /> : null
                }
                <div className="category-container">

                    <CategoryFilter onApply={(filter) => {
                        setfilterData(filter)
                        getitems(filter)
                    }}
                        filterData={filterData}
                        hidefilter={hidefilter}
                        viewModal={viewModal}
                        defaultkey="0"
                        setviewModal={() => { setviewModal(!viewModal) }}
                        defultFilter = {{ ...params } || {}}
                        resetFilter={() => {
                            if ( prevCategoryData.current && typeof location.pathname === 'string' && location.pathname.startsWith('/category') ) {                            
                                props.history.replace(formCategoryUrlPath(prevCategoryData.current.categoryGroup, prevCategoryData.current.category));
                            }

                            setfilterfromprops(prevCategoryData.current, true);
                        }} />
                    <div className="w-100">
                        {windowwidth > 800 ? <div className="w-20">
                            <SortingItem onApply={(sortData) => {
                                sortval.current = sortData
                                getitems(filterData)
                            }}
                            sortvalue={sortvalue} />
                        </div> :
                            <div className="d-flex align-items-end gap-3 px-3">
                                <div className="w-50">
                                    <SortingItem  onApply={(sortData) => {
                                         sortval.current = sortData
                                        getitems(filterData)
                                    }}
                                    sortvalue={sortvalue}
                                     />
                                </div>
                                <div className="w-50">
                                    <Button className="w-100 border  btn-white" onClick={() => { setviewModal(!viewModal) }}>Filter Results</Button>
                                </div>
                            </div>}
                        <PaginationListHOC
                            config={configeredData}
                            emptyCont={<div className='d-flex align-items-center flex-column text-center text-secondary'>
                                <div className='emptyhead'>This amazing CTBids auction does not have any listings for {(filterData?.categoryGroup) && `${filterData?.categoryGroup} `} {(filterData?.category) && `/${filterData?.category} `}  </div>
                                <div className='emptyhead'>Browse other {filterData?.categoryGroup && `categories `} in this estate sale now! </div>
                            </div>}
                        />
                    </div>

                </div>
            </div></>

    )
}